import { createRoute, useNavigate } from "@tanstack/react-router";
import { ReviewDesk, ScannerDevices } from "@/features/review";
import { rootRoute } from "./root";

export const reviewDevicesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/review/devices",
  component: function ReviewDevices() {
    const navigate = useNavigate();
    return (
      <ReviewDesk>
        <ScannerDevices onBack={() => navigate({ to: "/review" })} />
      </ReviewDesk>
    );
  },
});
